import React, { Component } from "react";
import { assessmentActions, questionsActions, userActions } from "../../../_actions";
import { connect } from "react-redux";
import Header from '../Component/Header';
import { BiMale } from "react-icons/bi";
import { FaFemale } from "react-icons/fa";
import { MdOutlineCheckCircle } from "react-icons/md";


class WelcomeProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      isModalOpen: false,
      formData: {
        fullName: "",
        selectedRole: "",
        gender: "",
      },
    };
  }

  handleNextStep = (e) => {
    e.preventDefault();
    const { step, formData } = this.state;
    if (step === 1 && !formData.fullName.trim()) return;
    if (step === 2 && !formData.selectedRole) return;
    if (step === 3 && !formData.gender) return;
    if (step === 3) {
      this.handleSubmitProfileDetails();
      this.setState({
        isModalOpen: true
      });
    } else {
      this.setState({
        step: step + 1
      });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  selectGender = (genderType) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        gender: genderType
      }
    }));
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, step: 1, fullName: '', selectedRole: '', gender: '' });
    console.log("Redirecting to Dashboard...");
  };



  handleSubmitProfileDetails = () => {
    const { formData } = this.state;
    console.log("Profile Data:", formData);
    this.props.dispatch(assessmentActions.saveProfileDetails(formData));
  };


  renderProgressBar = () => {
    const { step } = this.state;
    return (
      <div className="flex flex-col items-center mb-8 select-none">
        <span className="text-sm font-semibold text-slate-500 mb-3">Questions {step} of 3</span>
        <div className="flex space-x-2 w-48 justify-center">
          <div className={`h-1 w-16 rounded-full transition-colors duration-300 ${step >= 1 ? 'bgcolor' : 'bg-blue-200'}`}></div>
          <div className={`h-1 w-16 rounded-full transition-colors duration-300 ${step >= 2 ? 'bgcolor' : 'bg-blue-200'}`}></div>
          <div className={`h-1 w-16 rounded-full transition-colors duration-300 ${step >= 3 ? 'bgcolor' : 'bg-blue-200'}`}></div>
        </div>
      </div>
    );
  };

  render() {

    const { formData, step, isModalOpen } = this.state;
    const { fullName, selectedRole, gender } = formData;
    let { questions, assessment, onLogout, switchToAdmin, openAIBot } = this.props;
    let { userAssessmentUserProfileData } = assessment;


    return (
      <div className="min-h-screen flex flex-col justify-between bg-gradient-to-b from-white via-[#E3F2FD] to-[#E3F2FD]">

        {/* Rendered Header Component */}
        <Header userInitials={this.state.currentUser} />

        {/* Main Content Area */}
        <main className="flex-grow flex flex-col items-center justify-center px-4 max-w-2xl w-full mx-auto pb-16">

          {this.renderProgressBar()}

          <form onSubmit={this.handleNextStep} className="w-full max-w-xl">

            {/* STEP 1: Full Name (image_0f54b7.png) */}
            {step === 1 && (
              <div className="animate-fadeIn">
                <h1 className="text-3xl font-bold text-slate-800 text-center mb-3">What should we call you?</h1>
                <p className="text-sm text-slate-500 text-center mb-10">We'll use this to personalise your experience.</p>
                <div className="mb-6">
                  <label className="block text-base font-medium text-slate-700 mb-2 text-left">Enter your full name</label>
                  <input type="text" name="fullName" value={fullName} onChange={this.handleInputChange} placeholder="Enter your full name" required className="w-full px-4 py-3 bg-white border border-slate-300 rounded-lg text-slate-800 placeholder-slate-400 focus:outline-none focus:border-blue-500 transition-colors" />
                </div>
              </div>
            )}

            {/* STEP 2: Role Selection (image_0f5492.png) */}
            {step === 2 && (
              <div className="animate-fadeIn">
                <h1 className="text-3xl font-bold text-slate-800 text-center mb-3">Which role best describes you?</h1>
                <p className="text-sm text-slate-500 text-center mb-10">This helps us tailor your career insights.</p>
                <div className="mb-6 relative">
                  <label className="block text-base font-medium text-slate-700 mb-2 text-left">Select Role</label>
                  <select name="selectedRole" value={selectedRole} onChange={this.handleInputChange} required className="w-full px-4 py-3 bg-white border border-slate-300 rounded-lg text-slate-800 appearance-none focus:outline-none focus:border-blue-500 transition-colors cursor-pointer">
                    <option value="" disabled hidden>Select</option>
                    <option value="student">Student</option>
                    <option value="professional">Working Professional</option>
                    <option value="recruiter">Recruiter / HR</option>
                    <option value="other">Other</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 top-7 flex items-center px-4 text-slate-700">
                    <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
            )}

            {/* STEP 3: Gender Identity (image_0f5471.png) */}
            {step === 3 && (
              <div className="animate-fadeIn">
                <h1 className="text-3xl font-bold text-slate-800 text-center mb-3">
                  How do you identify?
                </h1>
                <p className="text-base text-slate-500 text-center mb-10">
                  Choose the option that best represents you.
                </p>
                <div className="grid grid-cols-2 gap-4 mb-8">

                  {/* Male Option */}
                  <div
                    onClick={() => this.selectGender('male')}
                    className={`cursor-pointer rounded-2xl p-5 border flex items-center justify-between transition-all bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] ${gender === 'male' ? 'border-blue-500 ring-1 ring-blue-500 bg-blue-50/10' : 'border-slate-200'
                      }`}
                  >
                    <div className="flex items-center space-x-3">
                      <BiMale size={30} className="text-slate-800" />
                      <span className="text-base font-semibold text-slate-800">Male</span>
                    </div>
                    <div className={`rounded-full flex items-center justify-center ${gender === 'male' ? 'text-blue-600' : 'w-6 h-6 border-2 border-slate-400'}`}>
                      {gender === 'male' && <MdOutlineCheckCircle size={28} className="text-blue-600" />}
                    </div>
                  </div>

                  {/* Female Option */}
                  <div
                    onClick={() => this.selectGender('female')}
                    className={`cursor-pointer rounded-2xl p-5 border flex items-center justify-between transition-all bg-white shadow-[0_4px_20px_rgba(0,0,0,0.02)] ${gender === 'female' ? 'border-blue-500 ring-1 ring-blue-500 bg-blue-50/30' : 'border-slate-200'
                      }`}
                  >
                    <div className="flex items-center space-x-3">
                      <FaFemale size={30} className="text-slate-800" />
                      <span className="text-base font-semibold text-slate-800">Female</span>
                    </div>
                    <div className={`rounded-full flex items-center justify-center ${gender === 'female' ? 'text-blue-600' : 'w-6 h-6 border-2 border-slate-400'}`}>
                      {gender === 'female' && (<MdOutlineCheckCircle size={28} className="text-blue-600" />)}
                    </div>
                  </div>

                </div>
              </div>
            )}

            {/* Core Continue Button */}
            <button
              type="submit"
              disabled={step === 3 && !gender}
              className={`w-full bgcolor hover:bg-blue-600 text-white font-medium py-3.5 rounded-xl transition-all duration-200 active:scale-[0.99] shadow-md shadow-blue-200 text-base ${step === 3 && !gender ? 'opacity-60 cursor-not-allowed' : ''
                }`}
            >
              Continue
            </button>
          </form>
        </main>


        {/* OVERLAY MODAL WINDOW (image_0f53f9.png) */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
            <div className="bg-white rounded-[2.5rem] p-8 md:p-12 max-w-lg w-full text-center shadow-2xl relative border border-white animate-scaleUp">
              <div className="text-5xl mb-6">🎉</div>
              <h2 className="text-3xl font-bold text-slate-800 mb-3">
                You're All Set!
              </h2>
              <p className="text-sm text-slate-500 max-w-xs mx-auto mb-8 leading-relaxed">
                Your profile is complete. Thanks for providing your details.
              </p>
              <button
                onClick={this.closeModal}
                className="w-full bgcolor hover:bg-blue-600 text-white font-semibold py-4 rounded-xl tracking-wider transition-all duration-150 uppercase text-sm shadow-md shadow-blue-100"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        )}

        {/* Footer Section */}
        <footer className="w-full text-center py-6 text-sm text-slate-600 tracking-wide">
          All Rights Reserved | Copyright © 2026 TalentPlusStrengths.
        </footer>

      </div>
    );
  }
}


function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}

export default connect(mapStateToProps)(WelcomeProfile);